export const OVERVIEW_COLUMNS = [
  {
    header: 'Page',
    name: 'page',
    className: 'min-w-50 w-100',
  },
  {
    header: 'Trend',
    name: 'trend',
    className: 'w-30',
  },
  {
    header: 'Page views',
    name: 'pageViews',
    className: 'w-25',
  },
  {
    header: 'Unique visitors',
    name: 'uniqVisitors',
    className: 'w-25',
  },
  {
    header: 'Owner',
    name: 'owner',
    className: 'w-20',
  },
  {
    header: 'Shared with',
    name: 'sharedWith',
    className: 'w-30',
  },
  {
    header: 'Last viewed',
    name: 'lastViewed',
    className: 'w-45',
  },
] as const;
